function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "spMenuCanaryReport_svg__a"
}, React.createElement("path", {
  d: "M14.997 8.915a1 1 0 111-1 1 1 0 01-1 1zm6.646 1.048L19.255 8.92a.5.5 0 01-.3-.4 5.086 5.086 0 00-5.558-4.495 5.251 5.251 0 00-4.563 5.273.58.58 0 01-.622.58A5.49 5.49 0 014.72 8.133a1 1 0 00-1.156-.2.978.978 0 00-.558.991 8.421 8.421 0 003.579 6.59.5.5 0 01.076.776c-.354.345-.94.863-2.571 2.391a1 1 0 00.68 1.733h6.006a8.225 8.225 0 008.192-7.65.5.5 0 01.259-.4l2.476-1.354a.584.584 0 00-.06-1.048z"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.997 8.915a1 1 0 111-1 1 1 0 01-1 1zm6.646 1.048L19.255 8.92a.5.5 0 01-.3-.4 5.086 5.086 0 00-5.558-4.495 5.251 5.251 0 00-4.563 5.273.58.58 0 01-.622.58A5.49 5.49 0 014.72 8.133a1 1 0 00-1.156-.2.978.978 0 00-.558.991 8.421 8.421 0 003.579 6.59.5.5 0 01.076.776c-.354.345-.94.863-2.571 2.391a1 1 0 00.68 1.733h6.006a8.225 8.225 0 008.192-7.65.5.5 0 01.259-.4l2.476-1.354a.584.584 0 00-.06-1.048z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#spMenuCanaryReport_svg__a)"
}, React.createElement("path", {
  d: "M-2-1h29.001v26.415H-2z"
}));

function SvgSpMenuCanaryReport(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "spMenuCanaryReport.0feac.svg";
export { SvgSpMenuCanaryReport as ReactComponent };